/**
 * Follow-up Intent Constants
 * Defines the possible follow-up intents when isFollowupRequired is true
 */

export const FOLLOW_UP_INTENTS = {
  PROVIDE: 'provide',
  ASK_ELSE: 'ask_else'
};

export const FOLLOW_UP_INTENT_LABELS = {
  [FOLLOW_UP_INTENTS.PROVIDE]: 'I\'ll provide this',
  [FOLLOW_UP_INTENTS.ASK_ELSE]: 'Ask something else'
};

export const FOLLOW_UP_INTENT_DESCRIPTIONS = {
  [FOLLOW_UP_INTENTS.PROVIDE]: 'Providing information',
  [FOLLOW_UP_INTENTS.ASK_ELSE]: 'Asking something else'
};

export const FOLLOW_UP_UI_TEXT = {
  WAITING_FOR: 'I\'m waiting for:',
  CURRENT_INTENT: 'Current follow-up intent:',
  UNKNOWN_INTENT: 'Unknown intent',
  UNKNOWN: 'Unknown',
  MISSING_INFO: 'missing information',
  CHANGE_INTENT_HINT: 'Click a button to change your follow-up intent',
  PROCESSING: 'Processing...',
  PLEASE_PROVIDE_PREFIX: 'Please provide: ',
  CONTEXT_CHANGED_REPLY_MESSAGE: 'Got it. What would you like to know about next?',
  READY_FOR_NEW_QUESTION: 'What\'s on your mind?',
  PROVIDE_INFO_FORM_TITLE: 'Please provide the following information:',
  PROVIDE_INFO_SUBMIT_BUTTON: 'Submit Information',
  PROVIDE_INFO_CANCEL_BUTTON: 'Cancel'
};

/**
 * Processing and UI timing constants
 */
export const PROCESSING_TIMEOUT = 500; // ms
export const SUCCESS_MESSAGE_TIMEOUT = 3000; // ms
